import React from 'react'
import { ContainerSingE } from '../../layouts/ContainerSingE/ContainerSingE'
import { NavUserE } from "../../ui/NavUserE/NavUserE";
import '../../pages/SingUPE/SingUPE.css'

export const SingUPE = () => {
  return (
    <div className="SingUPpageE">
        <NavUserE/>
        <ContainerSingE/>
  </div>
  )
}
